import { Navigate, Outlet } from 'react-router';
import { useSubscription } from '../../hooks/subscription/use-subscription';
import { isGuardQuerySettling } from './guard-query-state';

interface MenuAddonGuardProps {
  redirectTo?: string;
}

/**
 * Route guard for the Menu add-on. Mirrors DdtAddonGuard's shape but checks
 * `SubscriptionInfo.menuAddonEnabled` instead of a role permission — this is a
 * per-tenant add-on toggle set by platform-admin
 * (`PATCH /admin/tenants/:id/menu-addon`), not a role grant.
 */
export function MenuAddonGuard({ redirectTo = '/home' }: MenuAddonGuardProps) {
  const { menuAddonEnabled, isPending, fetchStatus } = useSubscription();
  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }
  if (!menuAddonEnabled) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
